export const testimonialsData = [
    {
        id: 1,
        content: "testimonials_1_designation",
        name: "testimonials_1_name",
      },
      {
        id: 2,
        content: "testimonials_2_designation",
        name: "testimonials_2_name",
      },
      {
        id: 3,
        content: "testimonials_3_designation",
        name: "testimonials_3_name",
      },
      {
        id: 4,
        content: "testimonials_4_designation",
        name: "testimonials_4_name",
      },
      {
        id: 5,
        content: "testimonials_5_designation",
        name: "testimonials_5_name"
    }
]